package org.moxultimate.topwithmox.architecture.ui

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch
import org.moxultimate.topwithmox.architecture.api.ArchitectureRepository
import org.moxultimate.topwithmox.core.base.ViewModel
import org.moxultimate.topwithmox.core.state.APIState


class ArchitectureViewModel(
    private val repository: ArchitectureRepository,
) : ViewModel() {

    private val _screenState = MutableStateFlow<ArchitectureState>(ArchitectureState.Loading)
    val screenState: StateFlow<ArchitectureState> = _screenState

    init {
        loadAllArchitectures()
    }

    /** Fetches all architectures from the API and updates [uiState]. */
    fun loadAllArchitectures() {
        viewModelScope.launch {
            repository.getAllArchitectures().collect { response ->
                _screenState.value = when (response) {
                    is APIState.Loading -> {
                        ArchitectureState.Loading
                    }
                    is APIState.Error -> {
                        ArchitectureState.Error(response.error)
                    }
                    is APIState.Success -> {
                        val data = response.data
                        if (data.isEmpty()) {
                            ArchitectureState.Empty
                        } else {
                            ArchitectureState.Success(architectureList = data)
                        }
                    }
                }
            }
        }
    }


    /**
     * Fetches a single architecture by [architectureId].
     */
    fun loadArchitecture(architectureId: Int) {
        viewModelScope.launch {
            repository.getSpecificArchitecture(architectureId).collect { response ->
                _screenState.value = when (response) {
                    is APIState.Loading -> {
                        ArchitectureState.Loading
                    }
                    is APIState.Error -> {
                        ArchitectureState.Error(response.error)
                    }
                    is APIState.Success -> {
                        val data = response.data
                        ArchitectureState.SuccessSingleData(architecture = data)
                    }
                }
            }
        }
    }


    /**
     * Creates a new architecture entry from [request].
     */
//    fun createArchitecture(request: ArchitectureRequest) {
//        viewModelScope.launch {
//            _uiState.update { it.copy(isLoading = true, error = null) }
//            when (val result = repository.createArchitecture(request)) {
//                is APIState.Success -> {
//                    _uiState.update { it.copy(isLoading = false) }
//                    _events.emit(ArchitectureEvent.RefreshList)
//                    loadAllArchitectures()
//                }
//
//                is APIState.Error -> {
//                    _uiState.update { it.copy(isLoading = false, error = result.error) }
//                    _events.emit(ArchitectureEvent.ShowError(result.error))
//                }
//
//                APIState.Loading -> Unit
//            }
//        }
//    }

    /**
     * Deletes the architecture identified by [architectureId].
     * Emits [ArchitectureEvent.RefreshList] and refreshes the list on success.
     */
//    fun deleteArchitecture(architectureId: Int) {
//        viewModelScope.launch {
//            _uiState.update { it.copy(isLoading = true, error = null) }
//            when (val result = repository.deleteArchitecture(architectureId)) {
//                is APIState.Success -> {
//                    _uiState.update { it.copy(isLoading = false) }
//                    _events.emit(ArchitectureEvent.RefreshList)
//                    loadAllArchitectures()
//                }
//
//                is APIState.Error -> {
//                    _uiState.update { it.copy(isLoading = false, error = result.error) }
//                    _events.emit(ArchitectureEvent.ShowError(result.error))
//                }
//
//                APIState.Loading -> Unit
//            }
//        }
//    }
}
